import React from 'react';
import cn from 'classnames';
import styles from './Card.module.scss';

const Card = ({ className, dark = false, ...props }) => {
  return (
    <div
      {...props}
      className={cn(styles.card, className, {
        [styles.bgLight]: !dark,
        [styles.bgDark]: dark,
      })}
    />
  );
};

export default Card;
